import React, { useMemo } from 'react'
import { MdErrorOutline } from 'react-icons/md'

import Modal from '../Modal'

import { ReactComponent as ConfirmIcon } from '../../assets/ConfirmIcon.svg'
import { ReactComponent as AlertDelete } from '../../assets/AlertDelete.svg'
import { ReactComponent as ShareIcon } from '../../assets/ShareIcon.svg'
import { ReactComponent as DeleteIcon } from '../../assets/DeleteIcon.svg'

import { IconsModal, MessageModal } from './styles'

interface ModalProps {
  tittle: string;
  textWishList: string;
  optionSVG: string;
  isOpen: boolean;
  onClose?: () => void;
  onClick?: () => void;
  buttonLabel?: string;
  classNameModal?: string;
}

const ModalMessage: React.FC<ModalProps> = ({
  tittle,
  textWishList,
  optionSVG,
  isOpen,
  onClick,
  onClose,
  buttonLabel,
  classNameModal
}) => {

  const modalConfig = useMemo(() => {
    switch (optionSVG) {
      case "warningInfoImage":
        return {
          modalImage: <AlertDelete className="svg__icon" />,
          buttonText: 'Fechar'
        }
      case "warningImage":
        return {
          modalImage: <AlertDelete className="svg__icon" />,
          buttonIcon: <DeleteIcon className="svg__icon--button" />,
          buttonText: 'Excluir'
        }
      case "successImage":
        return {
          modalImage: <ConfirmIcon className="svg__icon" />,
          buttonIcon: <ShareIcon className="svg__icon--button" />,
          buttonText: 'Compartilhar'
        }

      case "errorImage":
        return {
          modalImage: <MdErrorOutline className="svg__icon error-icon" />,
          buttonText: 'Fechar'
        }

      default:
        return {
          modalImage: <AlertDelete className="svg__icon" />,
          buttonIcon: <DeleteIcon className="svg__icon--button" />,
          buttonText: 'Excluir'
        }
    }
  }, [optionSVG])

  const contentButtonMemo = useMemo(() => (
    <div className="button__modal">
      {modalConfig.buttonIcon}
      <span> { buttonLabel || modalConfig.buttonText} </span>
    </div>
  )
    , [buttonLabel, modalConfig.buttonIcon, modalConfig.buttonText])

  return (
    <Modal
      onClick={onClick || onClose}
      contentButton={contentButtonMemo}
      onClose={onClose} isOpen={isOpen}
      classNameBackdropModal={classNameModal}
    >
      <MessageModal>
        <IconsModal>
          {modalConfig.modalImage}
        </IconsModal>

        <h1>
          {tittle}
        </h1>

        <p>
          {textWishList}
        </p>
      </MessageModal>
    </Modal>
  )
}

export default ModalMessage